import { createFileRoute } from '@tanstack/react-router';
import { SurveyDetailPage, resolveSurveyDetailTab, type SurveyDetailTab } from '@/features/marketing/surveys';

type SurveySearch = { tab?: SurveyDetailTab };

/**
 * One survey — `/marketing/surveys/{id}` (its own screen, not nested in the list); the page sets its own title.
 * `?tab=results` opens its Results; no tab (the default) is the Questions builder.
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/surveys_/$surveyId')({
  validateSearch: (search: Record<string, unknown>): SurveySearch =>
    resolveSurveyDetailTab(search.tab) === 'results' ? { tab: 'results' } : {},
  component: SurveyRoute,
});

function SurveyRoute() {
  const { orgId, surveyId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <SurveyDetailPage routeOrgId={orgId} surveyId={surveyId} tab={resolveSurveyDetailTab(tab)} />;
}
